const getters = {
    userName: state => state.user.userName,
    abpConfig: state => state.app.abpConfig,
    user: state => state.user,
    name: state => state.user.name,
    active:state=>state.app.active
}
export default getters
